export type Appearance = "light" | "dark" | "system";

export const APPEARANCE_CACHE_KEY = "waggle_appearance";

export function isAppearance(value: unknown): value is Appearance {
  return value === "light" || value === "dark" || value === "system";
}

// `undefined` (no user, no saved setting, request failed) means "system".
export function resolveTheme(
  appearance: Appearance | undefined,
  systemPrefersDark: boolean,
): "light" | "dark" {
  if (appearance === "light" || appearance === "dark") return appearance;
  return systemPrefersDark ? "dark" : "light";
}

export function readCachedAppearance(): Appearance | undefined {
  try {
    const value = localStorage.getItem(APPEARANCE_CACHE_KEY);
    return isAppearance(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function writeCachedAppearance(appearance: Appearance | undefined): void {
  try {
    if (appearance) localStorage.setItem(APPEARANCE_CACHE_KEY, appearance);
    else localStorage.removeItem(APPEARANCE_CACHE_KEY);
  } catch {
    // Storage can be unavailable (private mode, blocked); the server value still applies.
  }
}
